function getSiblingIndex(element, filterHidden = true) {
	if (!element || !element.parentElement) return -1

	const siblings = Array.from(element.parentElement.children).filter((sibling) => {
		if (!filterHidden) return true
		return !sibling.classList.contains('hidden')
	})
	return siblings.indexOf(element)
}

function getVisibleSlide(swiperInstance, index = null, flag = null) {
	if (!swiperInstance?.slides?.length) return null

	const targetIndex = index ?? swiperInstance.activeIndex
	const rawSlide = swiperInstance.slides[targetIndex]
	if (!rawSlide) return null
	if (!rawSlide.classList.contains('hidden')) return rawSlide

	const visibleIndex = index || getSiblingIndex(rawSlide)
	const visibleSlides = Array.from(rawSlide.parentElement.children).filter(
		(sibling) => !sibling.classList.contains('hidden'),
	)

	return visibleIndex > -1 ? visibleSlides[visibleIndex] : visibleSlides[0] || rawSlide
}

function syncProductMediaSliderHeight(swiperInstance) {
	if (!swiperInstance?.el || !swiperInstance?.wrapperEl) return false

	const activeSlide = getVisibleSlide(swiperInstance)
	if (!activeSlide) return false

	const image = activeSlide.querySelector('img')
	const imageWidth = image?.naturalWidth || Number(image?.getAttribute('width')) || 0
	const imageHeight = image?.naturalHeight || Number(image?.getAttribute('height')) || 0
	const sliderWidth = swiperInstance.el.getBoundingClientRect().width
	let height = activeSlide.getBoundingClientRect().height

	/*
	 * Swiper kann waehrend eines Zwischenzustands die addierten Hoehen aller
	 * Slides melden. Deshalb wird die Galerie auf allen Viewports aus dem
	 * stabilen Bildseitenverhaeltnis berechnet. Das verhindert sowohl den langen
	 * Leerraum beim Erstaufruf als auch falsche Hoehen nach Variantenwechseln.
	 */
	if (imageWidth > 0 && imageHeight > 0 && sliderWidth > 0) {
		height = Math.round(sliderWidth * imageHeight / imageWidth)
	}

	const computedMaxHeight = Number.parseFloat(window.getComputedStyle(swiperInstance.el).maxHeight)
	if (Number.isFinite(computedMaxHeight) && computedMaxHeight > 0) {
		height = Math.min(height, computedMaxHeight)
	}

	if (!(height > 0)) return false

	swiperInstance.wrapperEl.style.height = `${height}px`
	swiperInstance.el.style.height = `${height}px`
	return true
}

const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-list, .js-media-list-mobile') &&
		document.querySelectorAll('.js-media-list, .js-media-list-mobile').length > 0
	) {
		document.querySelectorAll('.js-media-list, .js-media-list-mobile').forEach((elem, index) => {
			let prevButton = elem.querySelector('.product__slider-nav .swiper-button-prev')
			let nextButton = elem.querySelector('.product__slider-nav .swiper-button-next')
			let pagination = elem.querySelector('.product__pagination')
			const initialSlide = elem.dataset.currentIndex || 0

			if (elem.swiper) {
				elem.swiper.destroy(true, true)
			}

			let swiperInstance = new Swiper(elem, {
				initialSlide: initialSlide,
				slidesPerView:
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--full_screen_top-mobile') ||
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--single_aside-mobile') ||
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--thumbs_aside-mobile')
						? 1
						: 1.1,
				spaceBetween: elem
					.closest('.product__outer')
					.classList.contains('product__gallery--multiple_top-mobile')
					? 0
					: 1,
				autoHeight: true,
				speed: 500,
				observer: true,
				freeMode: {
					enabled:
						window.innerWidth < 750
							? elem
									.closest('.product__outer')
									.classList.contains('product__gallery--multiple_top-mobile')
							: elem.closest('.product__outer').classList.contains('product__outer--multiple-top'),
					sticky: true,
				},
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					clickable: true,
				},
				// thumbs: {
				// 	swiper: elem.nextElementSibling.querySelector('.js-media-sublist')?.swiper
				// 		? elem.nextElementSibling.querySelector('.js-media-sublist').swiper
				// 		: '',
				// },
				breakpoints: {
					750: {
						slidesPerView:
							elem.closest('.product__outer').classList.contains('product__outer--full-screen') ||
							elem.closest('.product__outer').classList.contains('product__outer--single-aside') ||
							elem.closest('.product__outer').classList.contains('product__outer--thumbs-aside')
								? 1
								: 1.1,
						spaceBetween: elem
							.closest('.product__outer')
							.classList.contains('product__outer--multiple-top')
							? 0
							: 1,
					},
					// Fixed
					990: {
						slidesPerView:
							elem.closest('.product__outer').classList.contains('product__outer--full-screen') ||
							elem.closest('.product__outer').classList.contains('product__outer--single-aside') ||
							elem.closest('.product__outer').classList.contains('product__outer--thumbs-aside')
								? 1
								: 2.37,
					},
				},
				on: {
					afterInit: function (swiper) {
						requestAnimationFrame(() => {
							syncProductMediaSliderHeight(swiper)
							const activeImage = getVisibleSlide(swiper)?.querySelector('img')
							if (activeImage && !activeImage.complete) {
								activeImage.addEventListener('load', () => syncProductMediaSliderHeight(swiper), { once: true })
							}
						})
						// if (
						// 	(document.querySelector('.product__outer--multiple-top') &&
						// 		window.innerWidth >= 750) ||
						// 	(document.querySelector('.product__gallery--multiple_top-mobile') &&
						// 		window.innerWidth < 750)
						// ) {
						// 	document.querySelectorAll('.product__media-toggle').forEach((elem) => {
						// 		elem.addEventListener('click', (e) => {
						// 			const target = e.currentTarget
						// 			const parentSlide = target.closest('.swiper-slide') || target.closest('.product__media-item')
						// 			const slideIndex = getSiblingIndex(parentSlide)

						// 			if (
						// 				document.querySelector('.js-popup-slider') &&
						// 				document.querySelector('.js-popup-slider').swiper
						// 			) {
						// 				document.querySelector('.js-popup-slider').swiper.slideTo(
						// 					Math.max(slideIndex, 0),
						// 				)
						// 			}
						// 		})
						// 	})
						// }
					},
					slideChangeTransitionStart: function () {
						const slider =
							document.querySelector('.js-media-list') ||
							document.querySelector('.js-media-list-mobile')
						if (
							document.querySelector('.js-media-sublist') &&
							document.querySelector('.js-media-sublist').swiper
						) {
							let loopIndex = 0;
							const thumbsSwiperEl = document.querySelector('.js-media-sublist');
							const thumbsSwiperSlides = thumbsSwiperEl.querySelectorAll('.swiper-slide');
							thumbsSwiperEl.swiper.slideTo(slider.swiper.activeIndex);
							thumbsSwiperSlides.forEach((slide) => {
								slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active');
								if (! slide.classList.contains('hidden')) {
									if (loopIndex === slider.swiper.activeIndex) {
										slide.classList.add('swiper-slide-active', 'swiper-slide-thumb-active');
									}
									loopIndex++;
								}
							});
						}
					},
					slideChange: function () {
						window.pauseAllMedia()
						this.params.noSwiping = false

						if (
							document.querySelector('.js-popup-slider') &&
							document.querySelector('.js-popup-slider').swiper &&
							!(
								(document.querySelector('.product__outer--multiple-top') &&
									window.innerWidth >= 750) ||
								(document.querySelector('.product__gallery--multiple_top-mobile') &&
									window.innerWidth < 750)
							)
						) {
							document.querySelector('.js-popup-slider').swiper.slideTo(this.activeIndex)
						}

						const activeSlide = getVisibleSlide(this, this.activeIndex, '03')
						if (activeSlide?.querySelector('model-viewer')) {
							activeSlide
								.querySelector('.shopify-model-viewer-ui__button--poster')
								.removeAttribute('hidden')
						}

						if (this.params.autoHeight) {
							requestAnimationFrame(() => {
								if (!syncProductMediaSliderHeight(this)) {
									this.updateAutoHeight(0)
								}
							})
						}
					},
					slideChangeTransitionEnd: function () {

					},
					touchStart: function () {
						const activeSlide = getVisibleSlide(this, null, '04')
						if (activeSlide?.querySelector('model-viewer')) {
							if (
								!activeSlide
									.querySelector('model-viewer')
									.classList.contains('shopify-model-viewer-ui__disabled')
							) {
								this.params.noSwiping = true
								this.params.noSwipingClass = 'swiper-slide'
							} else {
								this.params.noSwiping = false
							}
						}
					},
				},
			})

			if (isUpdate) {
				setTimeout(() => {
					swiperInstance.update()
				}, 800)
			}
		})

		const pageResizeObserve = new ResizeObserver((entries) => {
			const [entry] = entries

			if (entry.contentRect.width < 750) {
				const slider = entry.target.querySelector('.js-media-list')
				const sliderMobile = entry.target.querySelector('.js-media-list-mobile')

				if (
					slider &&
					slider.swiper &&
					(entry.target.querySelector('.product__gallery--static_multicolumns_aside-mobile') ||
						entry.target.querySelector('.product__gallery--static_column_aside-mobile'))
				) {
					slider.swiper.destroy(true, true)
				}

				if (sliderMobile && !slider) {
					if (!sliderMobile.swiper) {
						subSliderInit(true)
						sliderInit(true)
						popupSliderInit(true)
					}
				}
			} else {
				const slider = entry.target.querySelector('.js-media-list')
				const sliderMobile = entry.target.querySelector('.js-media-list-mobile')

				if (sliderMobile && sliderMobile.swiper && !slider) {
					sliderMobile.swiper.destroy(true, true)
				}

				if (slider) {
					if (!slider.swiper) {
						subSliderInit(true)
						sliderInit(true)
						popupSliderInit(true)
					}
				}
			}
		})

		if (document.querySelector('.product-section'))
			pageResizeObserve.observe(document.querySelector('.product-section'))
	}
}

document.addEventListener('click', (event) => {
	const anchor = event.target.closest('a[href^="#"]')
	if (!anchor) return

	const hash = anchor.getAttribute('href')
	if (!hash || hash === '#') return

	const target = document.querySelector(hash)
	if (target && target.classList.contains('collapsible-content__item')) {
		event.preventDefault();

		const scrollToTarget = () => {
			const headerHeight =
				document.querySelector('.shopify-section-header')?.getBoundingClientRect().height || 0
			const top = target.getBoundingClientRect().top + window.scrollY - headerHeight
			window.scrollTo({ top, behavior: 'smooth' })
		}

		const toggle = target.querySelector('.collapsible-content__toggle')
		if (toggle) {
			let toggleParent = toggle.closest('.collapsible-content__item')
			if (toggleParent) {
				let accordionContent = toggleParent.querySelector('.collapsible-content__answer');
				toggleParent.classList.add('active');
				if (accordionContent) {
					accordionContent.style.display = 'block';
				}
			}
		}
		setTimeout(() => {
			scrollToTarget();
		}, 500);
	}
})

const handleMediaSubitemClick = (event) => {
	const element = event.currentTarget
	const parentElement = element.closest('.product__media-wrapper')
	const mainSliderElement = parentElement?.querySelector('.js-media-list, .js-media-list-mobile')
	const index = getSiblingIndex(element)

	if (mainSliderElement?.swiper && index > -1) {
		mainSliderElement.swiper.slideTo(index)
	}
}

const initMediaSubitems = () => {
	document.querySelectorAll('.product__media-subitem').forEach((element) => {
		element.removeEventListener('click', handleMediaSubitemClick)
		element.addEventListener('click', handleMediaSubitemClick)
	})
}

const subSliderInit = (isUpdate) => {
	initMediaSubitems()
	if (
		document.querySelectorAll('.js-media-sublist') &&
		document.querySelectorAll('.js-media-sublist').length > 0
	) {
		document.querySelectorAll('.js-media-sublist').forEach((elem, index) => {
			if (elem.swiper) elem.swiper.destroy()
			const isThumbsAside = elem.classList.contains('sublist-thumbs-aside')

			const breakpoint = isThumbsAside ? 1100 : 990

			let subSlider = new Swiper(elem, {
				slidesPerView: 'auto',
				// spaceBetween: 8,
				direction: 'horizontal',
				direction: 'horizontal',
				freeMode: false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				autoHeight: false,
				observer: true,
				// controller: {
				// 	control: elem.closest('.product__media-wrapper').querySelector('.js-media-list')?.swiper
				// 		? elem.closest('.product__media-wrapper').querySelector('.js-media-list').swiper
				// 		: ''
				// },
				on: {
					afterInit: function () {
						//this.params.slidesPerView = this.slides.length === 2 ? 2 : 3;
					},
					touchEnd: function (s, e) {
						let range = 5
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY)
						if (diff < range || diff > -range) s.allowClick = true
					},
				},
				//transitionStart: function () {
				//	document
				//		.querySelector(".js-media-list")
				//		.swiper.slideTo(
				//			document.querySelector(".js-media-sublist").swiper.activeIndex,
				//		);
				//},
				breakpoints: {
					[breakpoint]: {
						// slidesPerView: 12,
						// spaceBetween: 8
						// direction: 'vertical',
						// slidesPerView: 'auto',
					}
				},
			})

			const sliderResizeObserve = new ResizeObserver((entries) => {
				const [entry] = entries
				// Fixed
				if (entry.contentRect.width >= breakpoint) {
					setTimeout(() => {
						const sliders = document.querySelectorAll('.js-media-list, .js-media-list-mobile')
						const thumbs = document.querySelectorAll('.product__media-sublist')

						const sliderHeight = sliders[index].getBoundingClientRect().height
						thumbs[index].style.height = `${sliderHeight - 1}px`
					}, 400)
				}
			})

			if (document.querySelector('.product-section'))
				sliderResizeObserve.observe(document.querySelector('.product-section'))
			if (document.querySelector('.product-section'))
				sliderResizeObserve.observe(document.querySelector('.product-section'))

			document.querySelectorAll('.featured-product-section').forEach((section) => {
				sliderResizeObserve.observe(section)
			})

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update()
				}, 800)
			}
		})
	}
}

const popupSliderInit = (isUpdate) => {
	if (document.querySelector('.js-popup-slider')) {
		let popupSlider = new Swiper(document.querySelector('.js-popup-slider'), {
			slidesPerView: 1,
			zoom: true,
			// quickfix before the launch, not sure if we won't need that soon
			allowTouchMove: true,
  			simulateTouch: true,
			// navigation: {
			// 	nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
			// 	prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
			// },
			navigation: false,
			// pagination: {
			// 	el: '.product-media-modal .product__pagination',
			// 	type: 'bullets',
			// 	clickable: true,
			// },
			pagination: false,
			on: {
				afterInit: function () {
					if (
						document.querySelector('.product__outer--static-multicolumns-aside') ||
						document.querySelector('.product__outer--static-column-aside') ||
						document.querySelector('.product__gallery--static_multicolumns_aside-mobile') ||
						document.querySelector('.product__gallery--static_column_aside-mobile')
					) {
						document
							.querySelectorAll('.product__media-list .product__media-toggle')
							.forEach((elem, index) => {
								elem.addEventListener('click', (e) => {
									if (
										document.querySelector('.js-popup-slider') &&
										document.querySelector('.js-popup-slider').swiper
									) {
										document.querySelector('.js-popup-slider').swiper.slideTo(index)
									}
								})
							})
					}
				},
				slideChange: function () {
					window.pauseAllMedia()
					this.params.noSwiping = false
					document.querySelector('.product-media-modal__content').classList.remove('zoom')
				},
				touchMove: function () {
					document.querySelector('.product-media-modal__content').classList.remove('zoom')
				},
				slideChangeTransitionEnd: function () {
					const activeSlide = getVisibleSlide(this, null, '05')
					if (activeSlide?.querySelector('model-viewer')) {
						activeSlide
							.querySelector('.shopify-model-viewer-ui__button--poster')
							.removeAttribute('hidden')
					}
				},
				touchStart: function () {
					const activeSlide = getVisibleSlide(this, null, '06')
					if (activeSlide?.querySelector('model-viewer')) {
						if (
							!activeSlide
								.querySelector('model-viewer')
								.classList.contains('shopify-model-viewer-ui__disabled')
						) {
							this.params.noSwiping = true
							this.params.noSwipingClass = 'swiper-slide'
						} else {
							this.params.noSwiping = false
						}
					}
				},
			},
		})

		if (isUpdate) {
			setTimeout(function () {
				popupSlider.update()
			}, 800)
		}
	}
}

if (navigator.userAgent.indexOf('iPhone') > -1) {
	document
		.querySelector('[name=viewport]')
		.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
}

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	)
}

;(function () {
	const headerDrawer = document.querySelector('header-drawer')
	if (!headerDrawer) return

	const drawerTabs = document.querySelectorAll('.mega-menu__tab')
	if (!drawerTabs) return

	drawerTabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			tab.classList.toggle('tab--active')
			const tabToggler = tab.querySelector('.mega-menu__tab-toggler')
			const initialExpanded = JSON.parse(tabToggler.getAttribute('aria-expanded'))
			tabToggler.setAttribute('aria-expanded', `${!initialExpanded}`)
		})
	})
})()

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button')
	summary.setAttribute('aria-expanded', 'false')

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id)
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open'),
		)
	})

	if (summary.closest('header-drawer')) return
	summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return

	const openDetailsElement = event.target.closest('details[open]')
	if (!openDetailsElement) return

	const summaryElement = openDetailsElement.querySelector('summary')
	openDetailsElement.removeAttribute('open')
	summaryElement.setAttribute('aria-expanded', false)
	summaryElement.focus()
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container)
	var first = elements[0]
	var last = elements[elements.length - 1]

	removeTrapFocus()

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return

		document.addEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault()
			last.focus()
		}
	}

	document.addEventListener('focusout', trapFocusHandlers.focusout)
	document.addEventListener('focusin', trapFocusHandlers.focusin)

	elementToFocus.focus()
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*',
		)
	})
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	document.querySelectorAll('video').forEach((video) => video.pause())
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin)
	document.removeEventListener('focusout', trapFocusHandlers.focusout)
	document.removeEventListener('keydown', trapFocusHandlers.keydown)

	if (elementToFocus && !elementToFocus.classList.contains('card-focused')) elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
	constructor() {
		super()
		this.input = this.querySelector('input')
		this.changeEvent = new Event('change', { bubbles: true })

		this.querySelectorAll('button').forEach((button) => {
			this.setMinimumDisable()

			button.addEventListener('click', this.onButtonClick.bind(this))
		})

		var eventList = ['paste', 'input']

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/

				if (numberRegex.test(e.currentTarget.value) || e.currentTarget.value === '') {
					e.currentTarget.value
				} else {
					e.currentTarget.value = 1
				}

				if (e.currentTarget.value === 1 || e.currentTarget.value === '') {
					this.previousElementSibling.classList.add('disabled')
				} else {
					this.previousElementSibling.classList.remove('disabled')
				}
			})
		}

		this.input.addEventListener('focusout', function (e) {
			if (e.currentTarget.value === '') {
				e.currentTarget.value = 1
			}
		})
	}

	setMinimumDisable() {
		if (this.input.value == 1) {
			this.querySelector('button[name="minus"]').classList.add('disabled')
		} else {
			this.querySelector('button[name="minus"]').classList.remove('disabled')
		}
	}

	onButtonClick(event) {
		event.preventDefault()
		const previousValue = this.input.value

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)

		this.setMinimumDisable()
	}
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

const serializeForm = (form) => {
	const obj = {}
	const formData = new FormData(form)
	for (const key of formData.keys()) {
		obj[key] = formData.get(key)
	}
	return JSON.stringify(obj)
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options['method'] || 'post'
	var params = options['parameters'] || {}

	var form = document.createElement('form')
	form.setAttribute('method', method)
	form.setAttribute('action', path)

	for (var key in params) {
		var hiddenField = document.createElement('input')
		hiddenField.setAttribute('type', 'hidden')
		hiddenField.setAttribute('name', key)
		hiddenField.setAttribute('value', params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default')
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default')
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute('data-provinces')
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none'
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option')
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ''
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option')
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}

class MenuDrawer extends HTMLElement {
	constructor() {
		super()

		this.mainDetailsToggle = this.querySelector('details')
		const summaryElements = this.querySelectorAll('summary')
		this.addAccessibilityAttributes(summaryElements)

		if (navigator.platform === 'iPhone')
			document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)

		this.addEventListener('keyup', this.onKeyUp.bind(this))
		this.addEventListener('focusout', this.onFocusOut.bind(this))
		this.bindEvents()
	}

	closePredictiveSearch() {
		document.querySelectorAll('predictive-search').forEach((predictiveSearch) => {
			if (typeof predictiveSearch.close === 'function') {
				predictiveSearch.close(false)
			}

			predictiveSearch.setAttribute('open', 'false')
			predictiveSearch.isOpen = false
			predictiveSearch.removeAttribute('loading')
			predictiveSearch.input?.setAttribute('aria-expanded', false)
		})
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this)),
		)
		this.querySelectorAll('button').forEach((button) => {
			if (this.querySelector('.toggle-scheme-button') === button) return
			if (this.querySelector('.header__localization-button') === button) return
			if (this.querySelector('.header__localization-lang-button') === button) return
			button.addEventListener('click', this.onCloseButtonClick.bind(this))
		})
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute('role', 'button')
			element.setAttribute('aria-expanded', false)
			element.setAttribute('aria-controls', element.nextElementSibling.id)
		})
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return

		const openDetailsElement = event.target.closest('details[open]')
		if (!openDetailsElement) return

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement)
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget
		const detailsElement = summaryElement.parentNode
		const isOpen = detailsElement.hasAttribute('open')

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault()
			isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement)
		} else {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))

			setTimeout(() => {
				detailsElement.classList.add('menu-opening')
			})
		}
	}

	openMenuDrawer(summaryElement) {
		this.closePredictiveSearch()

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})
		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening')
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open')
				details.classList.remove('menu-opening')
			})
			this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
			removeTrapFocus(elementToFocus)
			this.closeAnimation(this.mainDetailsToggle)
			this.header = this.header || document.querySelector('.shopify-section-header')
			const main = document.querySelector('main')
			if (
				main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay') &&
				!this.header.classList.contains('animate')
			) {
				this.header.classList.add('color-background-1', 'color-background-3')
			}
			if (
				this.header.classList.contains('color-background-1') &&
				!this.header.classList.contains('shopify-section-header-sticky')
			) {
				this.header.classList.add('color-background-3')
			}
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				if (this.classList.contains('mobile-facets__wrapper')) this.closeMenuDrawer()
				else this.closeMenuDrawer(event)
		})
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details')
		this.closeSubmenu(detailsElement)
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening')
		removeTrapFocus()
		this.closeAnimation(detailsElement)
	}

	closeAnimation(detailsElement) {
		let animationStart

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			} else {
				detailsElement.removeAttribute('open')
				if (detailsElement.closest('details[open]')) {
					trapFocus(
						detailsElement.closest('details[open]'),
						detailsElement.querySelector('summary'),
					)
				}
			}
		}

		window.requestAnimationFrame(handleAnimation)
	}
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}

	openMenuDrawer(summaryElement) {
		this.closePredictiveSearch()

		this.header = this.header || document.querySelector('.shopify-section-header')
		this.borderOffset =
			this.borderOffset ||
			this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
				? 1
				: 0
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
		)

		if (
			this.header.classList.contains('color-background-3') &&
			!this.header.classList.contains('shopify-section-header-sticky')
		) {
			this.header.classList.remove('color-background-3')
		}

		const main = document.querySelector('main')
		if (main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay')) {
			this.header.classList.remove('color-background-3')
		}

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})

		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false))
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide()
		})
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
					this.hide()
			})
		} else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide()
			})
		}
	}

	connectedCallback() {
		if (this.moved) return
		this.moved = true
		document.body.appendChild(this)
	}

	show(opener) {
		this.openedBy = opener
		const popup = this.querySelector('.template-popup')
		document.body.classList.add('overflow-hidden')
		this.setAttribute('open', '')
		if (popup) popup.loadContent()
		trapFocus(this, this.querySelector('[role="dialog"]'))
		window.pauseAllMedia()
	}

	hide() {
		let isOpen = false

		this.removeAttribute('open')
		removeTrapFocus(this.openedBy)
		window.pauseAllMedia()

		document.querySelectorAll('body > quick-add-modal').forEach((el) => {
			if (el.hasAttribute('open')) {
				isOpen = true
			}
		})

		if (!isOpen) {
			document.body.classList.remove('overflow-hidden')
			document.body.dispatchEvent(new CustomEvent('modalClosed'))
		}

		const images = document.querySelector('.product-media-modal__content')

		if (images) {
			images.classList.remove('zoom')
		}

		if (this.openedBy && this.openedBy.closest('.js-media-list, .js-media-list-mobile')) {
			requestAnimationFrame(() => {
				this.openedBy.blur()
			})
		}
	}
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
	constructor() {
		super()

		const button = this.querySelector('button')

		if (!button) return
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'))
			if (modal) modal.show(button)
		})
	}
}

customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			'click',
			this.loadContent.bind(this),
		)
	}

	loadContent() {
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

			this.setAttribute('loaded', true)
			window.pauseAllMedia()
			this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()

			if (
				this.closest('.swiper')?.swiper.slides[
					this.closest('.swiper').swiper.activeIndex
				].querySelector('model-viewer')
			) {
				if (
					!this.closest('.swiper')
						.swiper.slides[this.closest('.swiper').swiper.activeIndex].querySelector('model-viewer')
						.classList.contains('shopify-model-viewer-ui__disabled')
				) {
					this.closest('.swiper').swiper.params.noSwiping = true
					this.closest('.swiper').swiper.params.noSwipingClass = 'swiper-slide'
				}
			}

			const modalOpener = this.closest('.product__media-item').querySelector('modal-opener');
			if (modalOpener) modalOpener.classList.add('hidden');
		}
	}
}

customElements.define('deferred-media', DeferredMedia)

const SOFA_DREAMS_PRODUCT_LINK_SELECTOR = [
	'.js-color-swatches-wrapper .js-color-swatches-link',
	'.js-color-swatches-wrapper .card__title a.full-unstyled-link',
].join(',')

function getSofaDreamsNativeVariantUrl(link, wrapper) {
	if (!link || !wrapper) return ''

	/*
	 * Immer die aktuell auf der Produktkarte dargestellte Variante verwenden.
	 * Das gilt fuer zufaellige Varianten auf normalen Collections genauso wie
	 * fuer Smart Collections, aktive Filter und manuell gewaehlte Swatches.
	 * Das crawlbare href bleibt weiterhin parameterfrei.
	 */
	const variantId = String(wrapper.dataset.selectedVariantId || '').trim()
	if (!variantId) return ''

	try {
		const url = new URL(
			wrapper.dataset.productUrl || link.href,
			window.location.origin,
		)
		url.searchParams.delete('option_values')
		url.searchParams.set('variant', variantId)
		url.hash = ''
		return url.href
	} catch (error) {
		return ''
	}
}

/*
 * Die crawlbaren href-Attribute der Collection bleiben parameterfrei.
 * Erst eine echte Nutzer-Navigation bekommt intern ?variant=ID, damit
 * Shopify die richtige Variante und Galerie bereits serverseitig rendert.
 */
document.addEventListener(
	'click',
	(event) => {
		if (!(event.target instanceof Element)) return

		const link = event.target.closest(SOFA_DREAMS_PRODUCT_LINK_SELECTOR)
		if (!link) return

		const wrapper = link.closest('.js-color-swatches-wrapper')
		const nativeVariantUrl = getSofaDreamsNativeVariantUrl(link, wrapper)
		if (!nativeVariantUrl) return

		/* Rechte Maustaste bleibt unangetastet. */
		if (event.button !== 0) return

		event.preventDefault()

		if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
			window.open(nativeVariantUrl, '_blank', 'noopener')
			return
		}

		window.location.assign(nativeVariantUrl)
	},
	true,
)

document.addEventListener(
	'auxclick',
	(event) => {
		if (event.button !== 1 || !(event.target instanceof Element)) return

		const link = event.target.closest(SOFA_DREAMS_PRODUCT_LINK_SELECTOR)
		if (!link) return

		const wrapper = link.closest('.js-color-swatches-wrapper')
		const nativeVariantUrl = getSofaDreamsNativeVariantUrl(link, wrapper)
		if (!nativeVariantUrl) return

		event.preventDefault()
		window.open(nativeVariantUrl, '_blank', 'noopener')
	},
	true,
)

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.onVariantChange = this.onVariantChange.bind(this)

    // ✅ NEU: URL erst nach echter User-Interaktion updaten
    this.userHasInteracted = false

    // Nur echte Bedienung setzt die URL-Interaktions-Flag.
    // Programmgesteuerte Initialisierung bleibt dadurch parameterfrei.
    this.addEventListener('change', (event) => {
      if (event.isTrusted) this.userHasInteracted = true
      this.onVariantChange(event)
    })

    this.initialVariantHandled = false
  }

	connectedCallback() {
		this.updateOptions()
		this.updateMasterId()
		//this.filterVariantMedia()

		if (!this.initialVariantHandled) {
			this.initialVariantHandled = true
			requestAnimationFrame(() => {
				this.applyInitialVariant()
			})
		}
	}

	onVariantChange() {
		this.updateOptions()
		this.updateMasterId()
		this.toggleAddButton(true, '', false, true)
		this.updatePickupAvailability()
		this.updateVariantStatuses()

		if (!this.currentVariant) {
			// try auto-selecting first valid color
  			this.reselectFirstAvailableOption()

			this.toggleAddButton(true, '', true)
			this.setUnavailable()
			this.filterVariantMedia()
		} else {
			this.filterVariantMedia()
			const finalizeVariantChange = () => {
				const featuredMediaId = this.currentVariant?.featured_media?.id
				if (!this.closest('floated-form') && featuredMediaId) {
					this.updateMedia(featuredMediaId)
				}
				this.updateURL()
				this.updateVariantInput()
				this.renderProductInfo()
			}

			const runWhenReady = () => {
				if (window.requestAnimationFrame) {
					requestAnimationFrame(() => requestAnimationFrame(finalizeVariantChange))
				} else {
					setTimeout(finalizeVariantChange, 0)
				}
			}

			runWhenReady()
		}
	}

	reselectFirstAvailableOption() {
		const selects = Array.from(this.querySelectorAll('select'))
		if (!selects.length) return

		const firstOptionValue = selects[0].value
		if (!firstOptionValue) return

		const matchingVariant = this.getVariantData().find(variant => variant.option1 === firstOptionValue && variant.available)

		if (!matchingVariant) return

		matchingVariant.options.forEach((value, index) => {
			const select = selects[index]
			if (!select) return

			const optionToSelect = Array.from(select.options).find(option => option.value === value && !option.disabled)

			if (optionToSelect && select.value !== value) {
				select.value = value

				// ✅ Trigger full variant lifecycle
				select.dispatchEvent(new Event('change', { bubbles: true }))
			}
		})
	}

	applyInitialVariant() {
		const initialVariant = window?.INITIAL_VARIANT

		if (initialVariant?.options?.length) {
			this.syncInputsToVariant(initialVariant)
		}

		this.onVariantChange()
	}

	syncInputsToVariant(variant) {
		const variantOptions = variant?.options || []
		if (!variantOptions.length) return

		const selects = this.querySelectorAll('select')
		variantOptions.forEach((value, index) => {
			const select = selects[index]
			if (select && select.value !== value) select.value = value
		})

		const fieldsets = this.querySelectorAll('fieldset')
		variantOptions.forEach((value, index) => {
			const fieldset = fieldsets[index]
			if (!fieldset) return

			const escapedValue =
				window.CSS && typeof window.CSS.escape === 'function'
					? window.CSS.escape(String(value))
					: String(value).replace(/["\\]/g, '\\$&')
			const radio = fieldset.querySelector(
				`input[type="radio"][value="${escapedValue}"]`,
			)

			if (radio && !radio.checked) radio.checked = true
		})
	}

	updateOptions() {
		// js-radio-colors was added to display Color swatches in the Dropdown type
		// but Color swatches are no longer supported in this type
		//const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
		//.concat(
		//	fieldsets.map((fieldset) => {
		//		return Array.from(fieldset.querySelectorAll("input")).find(
		//			(radio) => radio.checked,
		//		).value;
		//	}),
		//);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				//this.options.sort();
				//variant.options.sort();

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option
					})
					.includes(false)
			})
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem)
		return styles.display === 'none' || styles.visibility === 'hidden'
	}


	updateMedia(mediaId) {
		if (!this.currentVariant || !mediaId) return

		const fullMediaId = `${this.dataset.section}-${mediaId}`
		const currentSection = document.querySelector(`[data-section="main-${this.dataset.section}"]`)

		if (currentSection) {
			this.mediaList = currentSection.querySelector('.product__media-list')
			const activeMedia = this.mediaList?.querySelector(`[data-media-id="${fullMediaId}"]`)

			this.mediaList?.querySelectorAll('[data-media-id]').forEach((element) => {
				element.classList.remove('active')
			})
			if (activeMedia) activeMedia.classList.add('active')

			const index = activeMedia ? Math.max(getSiblingIndex(activeMedia), 0) : 0
			const productMediaList = this.closest('.product__outer')?.querySelector('.product__media-list')
			if (productMediaList) productMediaList.dataset.currentIndex = index
		}

		const swiperWrappers = document.querySelectorAll('.product__media-wrapper')

		swiperWrappers.forEach((elem) => {
			if (this.isHidden(elem)) return

			const newMedia = elem.querySelector(`[data-media-id="${fullMediaId}"]`)
			const desktopSlider = elem.querySelector('.js-media-list')?.swiper
			const mobileSlider = elem.querySelector('.js-media-list-mobile')?.swiper
			const thumbsContainer = elem.querySelector('.product__media-sublist')
			const thumbsSlider = thumbsContainer?.swiper
			const newIndex = getSiblingIndex(newMedia)
			const newIndexReal = getSiblingIndex(newMedia, false)

			if (desktopSlider && newIndex > -1) {
				desktopSlider.slideTo(newIndex, 0)
				desktopSlider.updateSlidesClasses()
				if (desktopSlider.params.autoHeight) {
					requestAnimationFrame(() => {
						if (!syncProductMediaSliderHeight(desktopSlider)) {
							desktopSlider.updateAutoHeight(0)
						}
					})
				}
			} else if (mobileSlider && newIndex > -1) {
				mobileSlider.slideTo(newIndex, 0)
				mobileSlider.updateSlidesClasses()
			}

			if (thumbsSlider && newIndex > -1) {
				thumbsSlider.slideTo(newIndex, 0)
				thumbsSlider.updateSlidesClasses()
				let loopIndex = 0
				thumbsContainer.querySelectorAll('.swiper-slide').forEach((slide) => {
					slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active')
					if (!slide.classList.contains('hidden')) {
						if (loopIndex === newIndex) {
							slide.classList.add('swiper-slide-active', 'swiper-slide-thumb-active')
						}
						loopIndex++
					}
				})
			}
		})

		const popupSliderEl = document.querySelector(`#ProductModal-${this.dataset.section} .js-popup-slider`)
		const popupSlider = popupSliderEl?.swiper
		if (popupSlider) {
			const popupTarget = popupSliderEl.querySelector(`[data-media-modal-id="${fullMediaId}"]`)
			const popupIndex = getSiblingIndex(popupTarget)
			if (popupIndex > -1) {
				popupSlider.slideTo(popupIndex, 0)
				popupSlider.updateSlidesClasses()
				requestAnimationFrame(() => {
					const activeSlide = getVisibleSlide(popupSlider, popupIndex)
					const height = activeSlide?.getBoundingClientRect().height || 0
					if (height) {
						popupSlider.wrapperEl.style.height = `${height}px`
						popupSlider.el.style.height = `${height}px`
					} else {
						popupSlider.updateAutoHeight?.(0)
					}
				})
			}
		}
	}

updateURL() {
  if (this.classList.contains('featured-product-radios')) return
  if (!this.currentVariant || this.dataset.updateUrl === 'false') return

  // ✅ NEU: Beim initialen Laden clean URL behalten
  if (!this.userHasInteracted) return

  window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', { bubbles: true }))
		})
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.option1,
		)
		const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
				)
				.map((variantOption) => variantOption[`option${index + 1}`])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
		})
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute('value')
				} else if (input.tagName === 'INPUT') {
					input.classList.remove('disabled')
				}
			} else {
				if (input.tagName === 'OPTION') {
					input.innerText = window.variantStrings.unavailable_with_option.replace(
						'[value]',
						input.getAttribute('value'),
					)
				} else if (input.tagName === 'INPUT') {
					input.classList.add('disabled')
				}
			}
		})
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability')
		if (!pickUpAvailability) return

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id)
		} else {
			pickUpAvailability.removeAttribute('available')
			pickUpAvailability.innerHTML = ''
		}
	}

	updateOptionValueNames() {
		const controls = this.querySelectorAll('.product-form__controls')
		controls.forEach((control) => {
			const valueTarget = control.querySelector('.product-form__group-value')
			if (!valueTarget) return

			const select = control.querySelector('select')
			const checked = control.querySelector('input[type="radio"]:checked')
			const value = select ? select.value : checked?.value

			if (value != null) valueTarget.textContent = value
		})
	}

	updatePriceInfo(variant) {
		const priceWrapper = document.getElementById(`price-${this.dataset.section}`)
		if (!priceWrapper) return

		const priceElement = priceWrapper.querySelector('.price')
		if (!priceElement) return

		const isOnSale = variant.compare_at_price > variant.price
		const isSoldOut = !variant.available
		const moneyPrice = formatMoney(variant.price)
		const moneyCompare = variant.compare_at_price ? formatMoney(variant.compare_at_price) : ''

		priceElement.classList.toggle('price--on-sale', isOnSale)
		priceElement.classList.toggle('price--sold-out', isSoldOut)

		const regularPrice = priceElement.querySelector('.price__regular .price-item--regular')
		const salePrice = priceElement.querySelector('.price__sale .price-item--sale')
		const comparePrice = priceElement.querySelector('.price__sale .price__compare .price-item--regular')

		if (regularPrice) regularPrice.textContent = moneyPrice
		if (salePrice) salePrice.textContent = moneyPrice
		if (comparePrice) comparePrice.textContent = moneyCompare

		const unitPrice = priceElement.querySelector('.unit-price')
		if (unitPrice) {
			const hasUnitPrice = !!variant.unit_price_measurement
			unitPrice.classList.toggle('hidden', !hasUnitPrice)
			if (hasUnitPrice) {
				const unitPriceValue = unitPrice.querySelector('dd > span')
				const unitPriceUnit = unitPrice.querySelector('dd > span:last-child')
				const referenceValue = variant.unit_price_measurement.reference_value
				const referenceUnit = variant.unit_price_measurement.reference_unit
				const unitText =
					referenceValue && referenceValue !== 1
						? `${referenceValue} ${referenceUnit}`
						: referenceUnit

				if (unitPriceValue) unitPriceValue.textContent = formatMoney(variant.unit_price)
				if (unitPriceUnit) unitPriceUnit.textContent = unitText
			}
		}

		// Keep the sticky add-to-cart bar in sync with the selected variant.
		// The sticky bar has its own price markup and is not part of priceWrapper.
		const productBarPriceWrapper = document.getElementById(
			`product-bar-price-${this.dataset.section}`,
		)
		const productBarPriceElement = productBarPriceWrapper?.querySelector('.price')

		if (productBarPriceElement) {
			productBarPriceElement.classList.toggle('price--on-sale', isOnSale)
			productBarPriceElement.classList.toggle('price--sold-out', isSoldOut)

			const productBarRegularPrice = productBarPriceElement.querySelector(
				'.price__regular .price-item--regular',
			)
			const productBarSalePrice = productBarPriceElement.querySelector(
				'.price__sale .price-item--sale',
			)
			const productBarComparePrice = productBarPriceElement.querySelector(
				'.price__sale .price__compare .price-item--regular',
			)

			if (productBarRegularPrice) productBarRegularPrice.textContent = moneyPrice
			if (productBarSalePrice) productBarSalePrice.textContent = moneyPrice
			if (productBarComparePrice) productBarComparePrice.textContent = moneyCompare
		}

		this.updateSaleBadge(priceWrapper, variant)
	}

	updateSaleBadge(priceWrapper, variant) {
		if (!priceWrapper) return
		if (priceWrapper.dataset.saleBadgeShow === 'false') {
			const existingBadgeWrapper =
				priceWrapper.querySelector('[data-sale-badge]') ||
				priceWrapper.querySelector('.product__badge')
			if (existingBadgeWrapper?.querySelector('.badge--sale')) existingBadgeWrapper.remove()
			return
		}

		const isOnSale = variant.available && variant.compare_at_price > variant.price
		let badgeWrapper =
			priceWrapper.querySelector('[data-sale-badge]') ||
			priceWrapper.querySelector('.product__badge')

		if (!isOnSale) {
			if (badgeWrapper?.querySelector('.badge--sale')) badgeWrapper.remove()
			return
		}

		const badgeText = priceWrapper.dataset.saleBadgeText || ''
		const badgeType = priceWrapper.dataset.saleBadgeType || 'sale'
		const colorScheme = priceWrapper.dataset.saleBadgeColorScheme
		const colorClass = colorScheme ? ` color-${colorScheme}` : ''

		if (!badgeWrapper || !badgeWrapper.querySelector('.badge--sale')) {
			badgeWrapper = document.createElement('div')
			badgeWrapper.className = 'product__badge'
			badgeWrapper.dataset.saleBadge = 'true'
			priceWrapper.appendChild(badgeWrapper)
		} else {
			badgeWrapper.dataset.saleBadge = 'true'
		}

		let badge = badgeWrapper.querySelector('.badge--sale')
		if (!badge) {
			badge = document.createElement('span')
			badge.setAttribute('aria-hidden', 'true')
			badgeWrapper.appendChild(badge)
		}
		badge.className = `badge badge--sale${colorClass}`

		const resolvedText = badgeText || badge.textContent || ''
		if (badgeType === 'sale') {
			badge.textContent = resolvedText
		} else {
			const percent = variant.compare_at_price
				? Math.round(
						((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price,
					)
				: 0
			badge.innerHTML = `${resolvedText} <span>${percent}%</span>`
		}
	}

	updateSku(variant) {
		const skuDestination = document.getElementById(`Sku-${this.dataset.section}`)
		if (!skuDestination) return

		const sku = variant.sku || ''
		const label = skuDestination.querySelector('.sku_prefix')
		const labelHtml = label ? label.outerHTML : ''

		skuDestination.innerHTML = `${labelHtml}${labelHtml ? ' ' : ''}${sku}`
		skuDestination.classList.toggle('visibility-hidden', !sku)
	}

	updateInventory(variant) {
    const destination = document.getElementById(`Inventory-${this.dataset.section}`)
    const inner = destination?.querySelector('.product__inventory-inner')
    if (!inner) return
    const data = destination.dataset
    let content = ''
    let statusClass = ''
    // Product delivery time is not a stock quantity. Variant JSON can omit inventory_quantity.
    if (data.inventoryUseCustom === 'true') {
      const message = data.inventoryCustomInStockText || ''
      content = message.trim() ? `${data.inventoryIconMore || ''} ${message}` : ''
      statusClass = 'product__inventory-inner--custom'
    } else {
      const quantity = variant.inventory_quantity == null ? NaN : Number(variant.inventory_quantity)
      if (!Number.isFinite(quantity)) {
        destination.classList.toggle('visibility-hidden', !inner.textContent.trim())
        return
      }
      if (quantity > 0) {
        const low = quantity < Number(data.inventoryThreshold || 10)
        const message = (data.inventoryInStockText || '').replace('[quantity]', quantity)
        content = `${low ? data.inventoryIconLess || '' : data.inventoryIconMore || ''} ${message}`
        statusClass = low ? 'product__inventory-inner--error' : ''
      } else {
        content = data.inventoryOutOfStockText || ''
        statusClass = 'product__inventory-inner--empty'
      }
    }
    inner.classList.remove('product__inventory-inner--custom', 'product__inventory-inner--error', 'product__inventory-inner--empty')
    if (statusClass) inner.classList.add(statusClass)
    inner.innerHTML = content
    destination.classList.toggle('visibility-hidden', !content.trim())
  }


	getSelectedNamedOptions() {
		const controls = Array.from(
			this.querySelectorAll('.product-form__controls[data-option-name]'),
		)

		return controls
			.map((control, index) => {
				const select = control.querySelector('select')
				const checked = control.querySelector('input[type="radio"]:checked')
				const value = select?.value ?? checked?.value ?? this.options?.[index] ?? ''

				return {
					name: (control.dataset.optionName || '').trim(),
					value: String(value || '').trim(),
					control,
				}
			})
			.filter((option) => option.name && option.value)
	}

	normalizeDynamicTitleOptionName(name) {
		return String(name || '')
			.trim()
			.toLocaleLowerCase('de-DE')
			.replace(/\s*:\s*$/u, '')
			.replace(/\s+/gu, ' ')
	}

	formatDynamicTitleValue(value) {
		return String(value || '')
			.trim()
			.replace(/(^|[\s\-/])([a-zäöüß])/giu, (match, separator, letter) => {
				return `${separator}${letter.toLocaleUpperCase('de-DE')}`
			})
	}

	escapeDynamicTitleRegExp(value) {
		return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	}

	stripTrailingMaterialFromDynamicTitle(title, materialOption) {
		let cleanTitle = String(title || '').trim()
		if (!materialOption) return cleanTitle

		const materialValues = Array.from(
			materialOption.control.querySelectorAll('input[value], option[value]'),
		)
			.map((input) => String(input.value || '').trim())
			.filter(Boolean)

		const removableValues = [...new Set(['Stoff', 'Leder', ...materialValues])]
			.sort((a, b) => b.length - a.length)

		for (const value of removableValues) {
			const escapedValue = this.escapeDynamicTitleRegExp(value)
			const suffixPattern = new RegExp(
				`\\s+(?:aus|in|mit)\\s+${escapedValue}\\s*$`,
				'iu',
			)
			cleanTitle = cleanTitle.replace(suffixPattern, '').trim()
		}

		return cleanTitle
	}

	updateDynamicProductTitle() {
		// Der originale Shopify-Artikelname bleibt beim ersten Seitenaufruf sichtbar.
		if (!this.userHasInteracted || !this.currentVariant) return

		const titleElement = document.querySelector(
			`#ProductInfo-${this.dataset.section} [data-dynamic-product-title]`,
		)
		if (!titleElement) return

		const selectedOptions = this.getSelectedNamedOptions()
		const materialNames = new Set([
			'material',
			'bezug',
			'bezugsstoff',
			'stoffart',
			'lederart',
		])
		const colorNames = new Set(['farbe', 'bezugsfarbe', 'color'])
		const directionNames = new Set([
			'ausrichtung',
			'ecke',
			'ottomane',
			'kurze seite',
			'lange seite',
		])

		const materialOption = selectedOptions.find((option) =>
			materialNames.has(this.normalizeDynamicTitleOptionName(option.name)),
		)
		const colorOption = selectedOptions.find((option) =>
			colorNames.has(this.normalizeDynamicTitleOptionName(option.name)),
		)
		const directionOptions = selectedOptions.filter((option) =>
			directionNames.has(this.normalizeDynamicTitleOptionName(option.name)),
		)

		const originalTitle =
			titleElement.dataset.baseTitle || titleElement.textContent.trim()
		let dynamicTitle = this.stripTrailingMaterialFromDynamicTitle(
			originalTitle,
			materialOption,
		)

		if (materialOption?.value) {
			dynamicTitle += ` aus ${this.formatDynamicTitleValue(materialOption.value)}`
		}

		if (colorOption?.value) {
			dynamicTitle += ` in ${this.formatDynamicTitleValue(colorOption.value)}`
		}

		if (directionOptions.length === 1) {
			dynamicTitle += `, ${this.formatDynamicTitleValue(directionOptions[0].value)}`
		} else if (directionOptions.length > 1) {
			const directionParts = directionOptions.map((option) => {
				const label = String(option.name || '').replace(/\s*:\s*$/u, '').trim()
				return `${label} ${this.formatDynamicTitleValue(option.value)}`
			})
			dynamicTitle += `, ${directionParts.join(', ')}`
		}

		titleElement.textContent = dynamicTitle.replace(/\s+/gu, ' ').trim()
	}

	renderProductInfo() {
		if (!this.currentVariant) return

		this.updateOptionValueNames()
		this.updateDynamicProductTitle()
		this.updatePriceInfo(this.currentVariant)
		this.updateSku(this.currentVariant)
		this.updateInventory(this.currentVariant)
    document.querySelectorAll('sofa-extras').forEach(widget => {
      if (widget.dataset.sectionId === this.dataset.section) widget.updateDisplayedPrice?.()
    })

		const price = document.getElementById(`price-${this.dataset.section}`)
		if (price) price.classList.remove('visibility-hidden')

		this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)

		const colorValueEl = this.querySelector('.product-form__controls--colors .product-form__group-value')
		const color = colorValueEl ? colorValueEl.textContent.trim() : null
		if (color) {
			const titleEl = document.querySelector(`#ProductInfo-${this.dataset.section} .product__title`)
			const productTitle = titleEl ? titleEl.textContent.trim() : null
			const productMain = document.querySelector(`.product__main[data-section="main-${this.dataset.section}"]`)
			if (productMain && productTitle) {
				productMain.querySelectorAll('.product__media img').forEach(img => {
					img.alt = productTitle + ' ' + color
					img.title = productTitle + ' ' + color
				})
			}
		}
	}

	toggleAddButton(disable = true, text, modifyClass = true, loading = false) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`)
		if (!productForm) return
		const addButton = productForm.querySelector('[name="add"]')
		const addButtonText = productForm.querySelector('[name="add"] > span')
		if (!addButton) return

		if (disable) {
			addButton.setAttribute('disabled', 'disabled')
			if (text) addButtonText.textContent = text
		} else {
			addButton.removeAttribute('disabled')
			addButtonText.textContent = window.variantStrings.addToCart
		}

		if (loading) {
			addButton.classList.add('is-loading')

		} else {
			addButton.classList.remove('is-loading')
		}

		if (!modifyClass) return
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`)
		const addButton = button.querySelector('[name="add"]')
		const price = document.getElementById(`price-${this.dataset.section}`)
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
		const sku = document.getElementById(`Sku-${this.dataset.section}`)

		if (!addButton) return
		this.toggleAddButton(true, window.variantStrings.unavailable)
		if (price) price.classList.add('visibility-hidden')
		if (inventory && inventory.dataset.inventoryUseCustom !== 'true') inventory.classList.add('visibility-hidden')
		if (sku) sku.classList.add('visibility-hidden')
	}

	updateSliderMedia(targetSwiperSelector, newMedia, targetWidth = null) {
		const swiperElement = document.querySelector(targetSwiperSelector)
		if (!swiperElement) return
		const slideWrapper = swiperElement.querySelector('.swiper-wrapper')
		const mediaList = newMedia.media
		if (!slideWrapper) return
		if(newMedia.media.length === 0) return

		const swiper = swiperElement?.swiper

		if(!swiper) return

		// select first .swiper-slide inside slideWrapper and use it as a base. Remove all other .swiper-slide Elements
		const baseSlides = slideWrapper.querySelectorAll('.swiper-slide')
		if (!baseSlides.length) return
		const baseSlide = baseSlides[0]
		baseSlides.forEach((slide, index) => {
			if (index === 0) return
			slide.remove()
		})

		// Remove class "swiper-slide-active"
		//baseSlide.classList.remove('swiper-slide-active')

		/**
		 * Create a copy of baseSlide for each media Element.
		 * A media element has a src and id attribute.
		 * Replace src and ids on the new element.
		 * After all, remove base Element
		 */
		mediaList.forEach((media, index) => {
			if (media.type === 'video') {
				const isSublist = targetSwiperSelector.includes('sublist')
				const isModal = targetSwiperSelector.includes('modal')
				let attr
				if (isSublist) attr = `[data-video-thumb="${media.id}"]`
				else if (isModal) attr = `[data-video-modal="${media.id}"]`
				else attr = `[data-video-gallery="${media.id}"]`
				const template = document.querySelector(`#variant-video-templates ${attr}`)
				if (template) slideWrapper.appendChild(template.firstElementChild.cloneNode(true))
				return
			}

			const newSlide = baseSlide.cloneNode(true)
			newSlide.removeAttribute('aria-label')

			if (newSlide.hasAttribute('data-media-sub-id')) {
				newSlide.setAttribute('data-media-sub-id', `${this.dataset.section}-${media.id}`)
			}
			else if (newSlide.hasAttribute('data-media-id')) {
				newSlide.setAttribute('data-media-id', `${this.dataset.section}-${media.id}`)
			}
			else if (newSlide.hasAttribute('data-media-modal-id')) {
				newSlide.setAttribute('data-media-modal-id', `${this.dataset.section}-${media.id}`)
			}

			// Replace all children with attr data-media-id
			newSlide.querySelectorAll('[data-media-id]').forEach((element) => {
				element.dataset.mediaId = media.id
			})

			// Replace image src and remove srcset
			let newSrc = media.src
			if(targetWidth) newSrc += `&width=${targetWidth}`
			const newSlideImg = newSlide.querySelector('img')
			if (!newSlideImg) return
			newSlideImg.setAttribute('src', newSrc)
			newSlideImg.removeAttribute('srcset')

			const isMainGallery = targetSwiperSelector.includes('media-list') && !targetSwiperSelector.includes('sublist')
			const isLcpImage = isMainGallery && index === 0
			newSlideImg.loading = isLcpImage ? 'eager' : 'lazy'
			newSlideImg.setAttribute('fetchpriority', isLcpImage ? 'high' : 'low')

			// When the image is loaded, set opacity to 1 with a fade-in effect
			newSlideImg.style.opacity = '0'
			newSlideImg.addEventListener('load', () => {
				newSlideImg.style.transition = 'opacity 0.2s ease-in-out'
				newSlideImg.style.opacity = '1'
			})

			slideWrapper.appendChild(newSlide)
		})

		baseSlide.remove();

		// Re-set aria-labels now that slide count and order are final
		const updatedSlides = slideWrapper.querySelectorAll('.swiper-slide')
		const total = updatedSlides.length
		updatedSlides.forEach((slide, i) => {
			slide.setAttribute('aria-label', `${i + 1} / ${total}`)
		})

		return swiper
	}

	filterVariantMedia() {
		const productWrapper = this.closest('.product')
		if (!productWrapper) return

		const variantId = this.currentVariant?.id ? this.currentVariant.id.toString() : null

		if (!variantId || !window.productMedia) return

		/*
		 * Die erste Variante ist bereits serverseitig mit korrektem LCP-Bild gerendert.
		 * Ein sofortiger Neuaufbau wuerde dasselbe Bild mit einer zweiten URL laden und
		 * alle Slides erneut erzeugen. Erst ein echter Variantenwechsel baut die Galerie um.
		 */
		if (!this.initialMediaConfirmed) {
			this.initialMediaConfirmed = true
			const initialVariantId = window.INITIAL_VARIANT?.id?.toString()
			if (initialVariantId && initialVariantId === variantId) {
				let heightSyncAttempts = 0
				const syncInitialHeight = () => {
					const initialSlider = productWrapper.querySelector('.product__media-list.swiper')?.swiper
					if (initialSlider && syncProductMediaSliderHeight(initialSlider)) return
					heightSyncAttempts += 1
					if (heightSyncAttempts < 20) window.setTimeout(syncInitialHeight, 50)
				}
				syncInitialHeight()
				return
			}
		}

		let targetVariantMedia = window.productMedia.find(media => media.id == variantId)
		if (!targetVariantMedia) return;

		/*
		 * Die Varianten-ID ist die einzige verbindliche Uebergabe aus der
		 * Collection. Das dort sichtbare Kartenbild darf die Produktgalerie
		 * nicht ueberschreiben, weil Bild und Variantenkombination bei manchen
		 * Produkten nicht 1:1 gekoppelt sind. Die Galerie wird ausschliesslich
		 * aus window.productMedia der korrekt ausgewaehlten Variante aufgebaut.
		 */

		const swipersToRefresh = new Set()

		let miniThumbnailWidth = 240;
		let thumbnailWidth = 1000;

		// if we are on mobile (< 700px)
		if(window.innerWidth < 700) {
			miniThumbnailWidth = 150;
			thumbnailWidth = 450;
		}

		swipersToRefresh.add(this.updateSliderMedia('.product .product__media-sublist.swiper', targetVariantMedia, miniThumbnailWidth))
		swipersToRefresh.add(this.updateSliderMedia('.product .product__media-list.swiper', targetVariantMedia, thumbnailWidth))
		swipersToRefresh.add(this.updateSliderMedia('.product-media-modal__content.swiper', targetVariantMedia))

		swipersToRefresh.forEach((swiperInstance) => {
			if(!swiperInstance) return;
			swiperInstance.update()
			swiperInstance.updateSlides()
			swiperInstance.updateSlidesClasses()
			requestAnimationFrame(() => {
				if (swiperInstance.el.classList.contains('product__media-list')) {
					if (!syncProductMediaSliderHeight(swiperInstance)) swiperInstance.updateAutoHeight(0)
				} else {
					swiperInstance.updateAutoHeight(0)
				}
			})
		})

		initMediaSubitems()
	}

	getVariantData() {
		this.variantData =
			this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
		return this.variantData
	}
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled')
			} else {
				input.classList.add('disabled')
			}
		})
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
		})
	}

	reselectFirstAvailableOption() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		if (!fieldsets.length) return

		const firstOptionValue = fieldsets[0].querySelector('input:checked')?.value

		if (!firstOptionValue) return

		const matchingVariant = this.getVariantData().find(variant => variant.option1 === firstOptionValue && variant.available)

		if (!matchingVariant) return

		matchingVariant.options.forEach((value, index) => {
			const fieldset = fieldsets[index]
			if (!fieldset) return

			const radioToSelect = fieldset.querySelector(`input[value="${CSS.escape(value)}"]:not(.disabled)`)

			if (radioToSelect && !radioToSelect.checked) {
				radioToSelect.checked = true

				// ✅ trigger full variant lifecycle
				radioToSelect.dispatchEvent(new Event('change', { bubbles: true }))
			}
		})
	}
}

customElements.define('variant-radios', VariantRadios)

class PasswordViewer {
	constructor() {
		const passwordField = document.querySelectorAll('.field--pass')

		passwordField.forEach((el) => {
			const input = el.querySelector('input')
			const btnWrapper = el.querySelector('.button-pass-visibility')
			const btnOpen = el.querySelector('.icon-eye-close')
			const btnClose = el.querySelector('.icon-eye')

			input.addEventListener('input', () => {
				input.value !== ''
					? (btnWrapper.style.display = 'block')
					: (btnWrapper.style.display = 'none')
			})

			btnOpen.addEventListener('click', () => {
				input.type = 'text'
				btnOpen.style.display = 'none'
				btnClose.style.display = 'block'
			})

			btnClose.addEventListener('click', () => {
				input.type = 'password'
				btnOpen.style.display = 'block'
				btnClose.style.display = 'none'
			})
		})
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super()

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div')
					html.innerHTML = text
					const recommendations = html.querySelector('product-recommendations')
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML
					}

										/* Farbswatch-Logik wird zentral durch product-card.js verarbeitet. */

					const calcTop = (section) => {
						const imageWrapper = section.querySelectorAll('.card__inner')
						let top = 0

						if (imageWrapper) {
							top = imageWrapper[0].offsetHeight / 2
						} else {
							top = 50
						}

						return top
					}

					const initSlider = () => {
						document.querySelectorAll('.js-recommendation-swiper').forEach((elem, index) => {
							let mobileLayout = 1
							if (elem.dataset.mobileLayout) {
								mobileLayout = elem.dataset.mobileLayout
							}
							let slider = new Swiper(elem, {
								slidesPerView: mobileLayout,
								slidesPerGroup: 1,
								spaceBetween: 8,
								speed: 1000,
								navigation: {
									nextEl: elem.querySelector(
										'.product-recommendations__slider-nav .swiper-button-next',
									),
									prevEl: elem.querySelector(
										'.product-recommendations__slider-nav .swiper-button-prev',
									),
								},
								breakpoints: {
									576: {
										slidesPerView: 2,
										slidesPerGroup: 2,
									},
									750: {
										slidesPerView: 3,
										slidesPerGroup: 3,
									},
									1200: {
										slidesPerView: 4,
										slidesPerGroup: 4,
									},
								},
							})
						})
					}

					const initSection = () => {
						const section = this

						const sectionResizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries
							let top = calcTop(section)
							if (section.querySelector('.product-recommendations__slider-nav'))
								section.querySelector('.product-recommendations__slider-nav').style.top = top + 'px'
						})

						sectionResizeObserver.observe(section)

						initSlider()
					}

					initSection()
				})
				.catch((e) => {
					console.error(e)
				})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 200px 0px',
		}).observe(this)
	}
}

customElements.define('product-recommendations', ProductRecommendations);

/* vDEV */
class CustomPopularProducts extends HTMLElement {

	constructor() {
		super()
	}

	connectedCallback() {
		const obj = this;

		obj.slider();
	}

	slider() {
		const obj = this;
		const recommendations = obj

		if (recommendations && recommendations.innerHTML.trim().length) {
			this.innerHTML = recommendations.innerHTML
		}

				/* Farbswatch-Logik wird zentral durch product-card.js verarbeitet. */

		const calcTop = (section) => {
			const imageWrapper = section.querySelectorAll('.card__inner')
			let top = 0

			if (imageWrapper) {
				top = imageWrapper[0].offsetHeight / 2
			} else {
				top = 50
			}

			return top
		}

		const initSlider = () => {
			this.querySelectorAll('.js-recommendation-swiper').forEach((elem, index) => {
				let mobileLayout = 1
				if (elem.dataset.mobileLayout) {
					mobileLayout = elem.dataset.mobileLayout
				}
				let slider = new Swiper(elem, {
					slidesPerView: mobileLayout,
					slidesPerGroup: 1,
					spaceBetween: 8,
					speed: 1000,
					navigation: {
						nextEl: elem.querySelector(
							'.product-recommendations__slider-nav .swiper-button-next',
						),
						prevEl: elem.querySelector(
							'.product-recommendations__slider-nav .swiper-button-prev',
						),
					},
					breakpoints: {
						576: {
							slidesPerView: 2,
							slidesPerGroup: 2,
						},
						750: {
							slidesPerView: 3,
							slidesPerGroup: 3,
						},
						1200: {
							slidesPerView: 4,
							slidesPerGroup: 4,
						},
					},
				})
			})
		}

		const initSection = () => {
			const section = this

			const sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				let top = calcTop(section)
				if (section.querySelector('.product-recommendations__slider-nav'))
					section.querySelector('.product-recommendations__slider-nav').style.top = top + 'px'
			})

			sectionResizeObserver.observe(section)

			initSlider()
		}

		initSection()
	}
}

customElements.define('custom--popular-products', CustomPopularProducts);
/* /vDEV */

class ProductUpsells extends HTMLElement {
	constructor() {
		super()

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div')
					html.innerHTML = text
					const recommendations = html.querySelector('product-recommendations')
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML
					}

										/* Farbswatch-Logik wird zentral durch product-card.js verarbeitet. */

					const calcTop = (section) => {
						const imageWrapper = section.querySelectorAll('.card__inner')
						let top = 0

						if (imageWrapper) {
							top = imageWrapper[0].offsetHeight / 2
						} else {
							top = 50
						}

						return top
					}

					const initSlider = () => {
						document.querySelectorAll('.js-recommendation-swiper').forEach((elem, index) => {
							let mobileLayout = 1
							if (elem.dataset.mobileLayout) {
								mobileLayout = elem.dataset.mobileLayout
							}

							mobileLayout = 1.5

							let slider = new Swiper(elem, {
								slidesPerView: mobileLayout,
								slidesPerGroup: 1,
								spaceBetween: 8,
								speed: 1000,
								navigation: {
									nextEl: elem.querySelector(
										'.product-recommendations__slider-nav .swiper-button-next',
									),
									prevEl: elem.querySelector(
										'.product-recommendations__slider-nav .swiper-button-prev',
									),
								},
								breakpoints: {
									576: {
										slidesPerView: 1.75,
										slidesPerGroup: 1.75,
									},
									750: {
										slidesPerView: 2.25,
										slidesPerGroup: 2.25,
									},
									1200: {
										slidesPerView: 2.25,
										slidesPerGroup: 2.25,
									},
								},
							})
						})
					}

					const initSection = () => {
						const section = this

						const sectionResizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries
							let top = calcTop(section)
							if (section.querySelector('.product-recommendations__slider-nav'))
								section.querySelector('.product-recommendations__slider-nav').style.top = top + 'px'
						})

						sectionResizeObserver.observe(section)

						initSlider()
					}

					initSection()
				})
				.catch((e) => {
					console.error(e)
				})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 200px 0px',
		}).observe(this)
	}
}

customElements.define('product-upsells', ProductUpsells);

(function () {
	const initHeaderOverlay = () => {
		const main = document.getElementById('MainContent')
		const sections = main.querySelectorAll('.shopify-section')
		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector('.section--has-overlay')
			const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group')
			const header = document.querySelector('.shopify-section-header')

			if (sectionFirstChild) {
				if (sectionFirstChild.classList.contains('section--has-overlay')) {
					if (headerGroupSections[headerGroupSections.length - 1] === header) {
						sections[0].classList.remove('not-margin')
						header.classList.add('color-background-1', 'color-background-3')
					} else {
						sections[0].classList.add('not-margin')
						header.classList.remove('color-background-1', 'color-background-3')
					}
				} else {
					sections[0].classList.remove('not-margin')
					header.classList.remove('color-background-1', 'color-background-3')
				}
			}
		}
	}

	initHeaderOverlay()

	document.addEventListener('shopify:section:load', function () {
		initHeaderOverlay()
	})

	document.addEventListener('shopify:section:unload', function () {
		initHeaderOverlay()
	})

	document.addEventListener('shopify:section:reorder', function () {
		initHeaderOverlay()
	})
})()

function formatMoney(cents, format = '') {
	if (typeof cents === 'string') {
		cents = cents.replace('.', '')
	}
	cents = parseInt(cents, 10)

	let value = ''
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || theme.moneyFormat

	function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
		if (isNaN(number) || number == null) {
			return '0'
		}

		number = (number / 100.0).toFixed(precision)

		const parts = number.split('.')
		const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`)

		const centsAmount = precision > 0 ? decimal + parts[1] : ''

		return dollarsAmount + centsAmount
	}

	const match = formatString.match(placeholderRegex)
	const formatType = match ? match[1] : 'amount'

	switch (formatType) {
		case 'amount':
			value = formatWithDelimiters(cents, 2, ',', '.')
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ',', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',')
			break
		case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters(cents, 2, "'", '.')
			break
		case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', ',')
			break
		case 'amount_with_period_and_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', '.')
			break
		default:
			value = formatWithDelimiters(cents, 2, ',', '.')
	}

	return formatString.replace(placeholderRegex, value)
}

/* vDEV */
document.addEventListener('DOMContentLoaded', () => {

	class HeaderTimer extends HTMLElement {

		constructor() {
			super();
		}

		connectedCallback() {

			this.parameters = {
				endDate: this.dataset.endDate,
				timer: this.dataset.timer,
				timerElement: this.querySelector('.header-timer__timer')
			};

			this.timer()
		}

		timer() {

			if (!this.parameters.endDate || !this.parameters.timer) {
				return;
			}

			this.parameters.endTime = new Date(this.parameters.endDate).getTime();
			this.parameters.interval = setInterval(this.updateTimer.bind(this), 1000);
			this.updateTimer();
		}

		updateTimer() {
			const nowTime = new Date().getTime();
			const distance = this.parameters.endTime - nowTime;

			if (distance < 0) {
				this.parameters.timerElement.classList.add('hidden');
				clearInterval(this.parameters.interval);
				return;

			} else {
				this.parameters.timerElement.classList.remove('hidden');
			}

			const days = Math.floor(distance / (1000 * 60 * 60 * 24));
			const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((distance % (1000 * 60)) / 1000);

			this.parameters.timerElement.textContent = this.parameters.timer.replace('{days}', days).replace('{hours}', hours).replace('{minutes}', minutes).replace('{seconds}', seconds);

		}
	}

	if (!customElements.get('header-timer')) {
		customElements.define('header-timer', HeaderTimer);
	}

	if (document.body.classList.contains('template-product')) {
		const productForm = document.querySelector('.product-form');
		const productBar = document.querySelector('.product-bar');

		if (productForm && productBar) {
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							document.body.classList.remove('product-bar--is-visible');
						} else {
							document.body.classList.add('product-bar--is-visible');
						}
					});
				},
				{
					threshold: 0
				}
			);

			observer.observe(productForm);
		}

		const notifyMe__button = document.querySelector('.product-form__buttons .button[data-klaviyo-id]');

		if (notifyMe__button) {

			notifyMe__button.addEventListener('click', () => {
				const notifyMe__buttonId = notifyMe__button.dataset.klaviyoId;

				window._klOnsite = window._klOnsite || [];
				window._klOnsite.push(['openForm', notifyMe__buttonId]);
			});
		}
	}

	const richTexts = document.querySelectorAll('.rich-text__text.has-collapse');

	richTexts.forEach((richText) => {
		const richText__contentHeight = parseFloat(richText.querySelector('.rich-text__text-content').offsetHeight);
		const richText__collapseHeight = parseFloat(richText.dataset.collapseHeight);

		if (richText__contentHeight > richText__collapseHeight) {
			richText.classList.add('is-collapsed');
			const richText__button = richText.querySelector('.rich-text__text-button .button');

			richText__button.addEventListener('click', () => {
				richText.classList.toggle('is-collapsed');
			})
		}
	});
});

const forms = document.querySelectorAll('form.contact-form, form.newsletter-form');

if (forms.length) {

	forms.forEach((form) => {
		const formMessages = form.querySelectorAll('.newsletter-form__message');

		if (!formMessages.length) {
			return;
		}

		formMessages.forEach((formMessage) => {

			if (window.location.hash != `#${form.id}`) {
				formMessage.remove();
			}
		});
	});
}
/* /vDEV */

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        );
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        // Temporarily prevents unneeded updates resulting from variant changes
        // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
        if (!this.slider || !this.nextButton) return;

        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(
                new CustomEvent('slideChanged', {
                    detail: {
                        currentPage: this.currentPage,
                        currentElement: this.sliderItemsToShow[this.currentPage - 1],
                    },
                })
            );
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
            event.currentTarget.name === 'next'
                ? this.slider.scrollLeft + step * this.sliderItemOffset
                : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.setSlidePosition(this.slideScrollPosition);
    }

    setSlidePosition(position) {
        this.slider.scrollTo({
            left: position,
        });
    }
}

customElements.define('slider-component', SliderComponent);
class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;

        // A slideshow can briefly exist without complete controls while Shopify
        // sections or app blocks are being re-rendered. Do not initialise timers
        // against an incomplete component.
        if (!this.sliderControlWrapper || !this.slider || !this.prevButton || !this.nextButton) return;

        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        if (!this.sliderFirstItemNode || !this.sliderItems?.length) return;
        if (this.sliderItemsToShow?.length > 0) this.currentPage = 1;

        this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
        // Value below should match --duration-announcement-bar CSS value
        this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.announcementBarSlider) {
            this.announcementBarArrowButtonWasClicked = false;

            this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
            this.reducedMotion.addEventListener('change', () => {
                if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
            });

            [this.prevButton, this.nextButton].forEach((button) => {
                button.addEventListener(
                    'click',
                    () => {
                        this.announcementBarArrowButtonWasClicked = true;
                    },
                    { once: true }
                );
            });
        }

        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }

    setAutoPlay() {
        this.autoplaySpeed = this.slider.dataset.speed * 1000;
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));

        if (this.querySelector('.slideshow__autoplay')) {
            this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
            this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
            this.autoplayButtonIsSetToPlay = true;
            this.play();
        } else {
            this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
        }
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        this.wasClicked = true;

        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) {
            this.applyAnimationToAnnouncementBar(event.currentTarget.name);
            return;
        }

        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition =
                this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0;
        }

        this.setSlidePosition(this.slideScrollPosition);

        this.applyAnimationToAnnouncementBar(event.currentTarget.name);
    }

    setSlidePosition(position) {
        if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
        this.setPositionTimeout = setTimeout(() => {
            this.slider.scrollTo({
                left: position,
            });
        }, this.announcerBarAnimationDelay);
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton?.removeAttribute('disabled');

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach((link) => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
        });
        const currentControlIndex = Math.min(
            Math.max((Number(this.currentPage) || 1) - 1, 0),
            this.sliderControlButtons.length - 1
        );
        const currentControl = this.sliderControlButtons[currentControlIndex];

        if (!currentControl) return;
        currentControl.classList.add('slider-counter__link--active');
        currentControl.setAttribute('aria-current', true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        if (this.sliderAutoplayButton) {
            const focusedOnAutoplayButton =
                event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
            if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
            this.play();
        } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
            this.play();
        }
    }

    focusInHandling(event) {
        if (this.sliderAutoplayButton) {
            const focusedOnAutoplayButton =
                event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
            if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
                this.play();
            } else if (this.autoplayButtonIsSetToPlay) {
                this.pause();
            }
        } else if (this.announcementBarSlider.contains(event.target)) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        if (!this.slider || !this.sliderItems?.length || !Number.isFinite(this.sliderItemOffset)) {
            this.pause();
            return;
        }

        const currentPage = Math.min(
            Math.max(Number(this.currentPage) || 1, 1),
            this.sliderItems.length
        );
        const slideScrollPosition =
            currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

        this.setSlidePosition(slideScrollPosition);
        this.applyAnimationToAnnouncementBar();
    }

    setSlideVisibility(event) {
        this.sliderItemsToShow.forEach((item, index) => {
            const linkElements = item.querySelectorAll('a');
            if (index === this.currentPage - 1) {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.removeAttribute('tabindex');
                    });
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.setAttribute('tabindex', '-1');
                    });
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
        this.wasClicked = false;
    }

    applyAnimationToAnnouncementBar(button = 'next') {
        if (!this.announcementBarSlider || !this.sliderItems?.length) return;

        const itemsCount = this.sliderItems.length;
        const increment = button === 'next' ? 1 : -1;

        // Scroll rounding can transiently report a page above the last slide.
        // Clamp it before accessing the static NodeList.
        const currentIndex = Math.min(
            Math.max((Number(this.currentPage) || 1) - 1, 0),
            itemsCount - 1
        );
        let nextIndex = (currentIndex + increment) % itemsCount;
        nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

        const nextSlide = this.sliderItems[nextIndex];
        const currentSlide = this.sliderItems[currentIndex];

        if (!currentSlide || !nextSlide) return;

        const animationClassIn = 'announcement-bar-slider--fade-in';
        const animationClassOut = 'announcement-bar-slider--fade-out';

        const isFirstSlide = currentIndex === 0;
        const isLastSlide = currentIndex === itemsCount - 1;

        const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
        const direction = shouldMoveNext ? 'next' : 'previous';

		currentSlide.classList.add(`${animationClassOut}-${direction}`);
		nextSlide.classList.add(`${animationClassIn}-${direction}`);

        setTimeout(() => {
			currentSlide.classList.remove(`${animationClassOut}-${direction}`);
			nextSlide.classList.remove(`${animationClassIn}-${direction}`);
        }, this.announcerBarAnimationDelay * 2);
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth *
            (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }
}

customElements.define('slideshow-component', SlideshowComponent);

document.addEventListener('DOMContentLoaded', () => {
	/* vDEV */
	const announcement = document.querySelector('.announcement-swiper');

	if (announcement && typeof window.Swiper === 'function') {
		new window.Swiper(announcement, {
			loop: true,
			autoplay: announcement.dataset.autoplay === 'true' ? {
				delay: Number(announcement.dataset.speed || 5) * 1000
			} : false,
			navigation: {
				nextEl: announcement.querySelector('.swiper-button-next'),
				prevEl: announcement.querySelector('.swiper-button-prev'),
			},
			speed: 400
		});
	}

	const headerSearchInput = document.querySelector('.header__search-form__input');
	const hiddenSearchInput = document.querySelector('.search-modal__form .search__input');

	if (headerSearchInput && hiddenSearchInput) {
		const syncValue = () => {
			hiddenSearchInput.value = headerSearchInput.value;
			hiddenSearchInput.dispatchEvent(new Event('input', { bubbles: true }));
		};

		headerSearchInput.addEventListener('input', syncValue);

		const headerSearchClear = document.querySelector('.header__search-form__clear');

		headerSearchClear.addEventListener('click', () => {
			headerSearchInput.value = '';

			hiddenSearchInput.value = '';
			hiddenSearchInput.dispatchEvent(new Event('input', { bubbles: true }));
		});

		const headerSearchBg = document.querySelector('.header__search-bg');

		headerSearchBg.addEventListener('click', () => {
			headerSearchInput.value = '';

			hiddenSearchInput.value = '';
			hiddenSearchInput.dispatchEvent(new Event('input', { bubbles: true }));
		});
	}
	/* /vDEV */

	// Trick with product variant options selector for faster performance
	const productOptions = document.querySelectorAll('[data-product-option]');
	productOptions && productOptions.forEach((option) => {
		option.addEventListener('change', (event) => {
			let value = option.value;
			let optionParent = option.closest('.product-form__controls');
			let caption = optionParent.querySelector('.product-form__group-value');
			if (caption && value) {
				caption.textContent = value;
			}
		});
	})

// Bildtitel werden nicht mehr global aus Alt-Texten dupliziert.
// Der fruehere documentweite MutationObserver verursachte bei dynamischen DOM-Aenderungen
// unnoetige Arbeit auf Collection-, Such- und Produktseiten. Fuer SEO und Barrierefreiheit
// ist der vorhandene Alt-Text massgeblich; ein identisches title-Attribut ist nicht erforderlich.

;(function () {
	function patchJudgemeImages(root) {
		root.querySelectorAll('img').forEach(img => {
			if (!img.title) img.title = img.alt || ''
			if (!img.alt) {
				if (img.classList.contains('jdgm-verified-checkmark')) {
					img.alt = 'Verifiziertes Häkchen'
					img.title = 'Verifiziertes Häkchen'
				} else if (img.classList.contains('jdgm-rev__author-pic')) {
					img.alt = img.title || 'Kundenfoto'
					img.title = img.alt
				} else {
					img.alt = 'Judge.me'
					img.title = 'Judge.me'
				}
			}
		})
	}

	const innerObservers = new WeakMap()

	function attachInner(container, patchFn) {
		if (innerObservers.has(container)) return
		patchFn(container)
		const inner = new MutationObserver(() => patchFn(container))
		inner.observe(container, { childList: true, subtree: true })
		innerObservers.set(container, inner)
	}

	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				if (node.nodeType !== 1) return
				const jdgm = node.classList && node.classList.contains('jdgm-legacy-widget-content')
					? node
					: node.querySelector && node.querySelector('.jdgm-legacy-widget-content, .jdgm-rev-widg')
				if (jdgm) attachInner(jdgm, patchJudgemeImages)
			})
		})
	})

	observer.observe(document.body, { childList: true, subtree: true })
})()
});
/* Wishlist Guru: unnötige App-Headings semantisch bereinigen */
(() => {
const targets = new Map([
  ['Deine Wunschliste ist leer', 'H4'],
  ['Wunschliste per E-Mail teilen', 'H3'],
  ['Andere Sharing-Optionen', 'H4'],
  ['Ihre E-Mail wurde gesendet', 'H3']
]);

  const visualProperties = [
    'display',
    'font-family',
    'font-size',
    'font-style',
    'font-weight',
    'line-height',
    'letter-spacing',
    'text-align',
    'text-transform',
    'color',
    'margin-top',
    'margin-right',
    'margin-bottom',
    'margin-left',
    'padding-top',
    'padding-right',
    'padding-bottom',
    'padding-left'
  ];

  function normalizeText(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function replaceWishlistHeading(element) {
    if (!(element instanceof HTMLElement)) return;

    const text = normalizeText(element.textContent);
    const expectedTag = targets.get(text);

    if (!expectedTag || element.tagName !== expectedTag) return;

    const replacement = document.createElement('div');
    const computedStyle = window.getComputedStyle(element);

    Array.from(element.attributes).forEach((attribute) => {
      replacement.setAttribute(attribute.name, attribute.value);
    });

    replacement.classList.add(
      'wishlist-app-heading',
      `wishlist-app-heading--${expectedTag.toLowerCase()}`
    );

    replacement.innerHTML = element.innerHTML;

    visualProperties.forEach((property) => {
      replacement.style.setProperty(
        property,
        computedStyle.getPropertyValue(property)
      );
    });

    element.replaceWith(replacement);
  }

  function scanWishlistHeadings(root = document) {
    if (
      root instanceof HTMLElement &&
      root.matches('h3, h4')
    ) {
      replaceWishlistHeading(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('h3, h4').forEach(replaceWishlistHeading);
    }
  }

  function initializeWishlistHeadingCleanup() {
    scanWishlistHeadings(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE ||
            node.nodeType === Node.DOCUMENT_FRAGMENT_NODE
          ) {
            scanWishlistHeadings(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeWishlistHeadingCleanup,
      { once: true }
    );
  } else {
    initializeWishlistHeadingCleanup();
  }
})();
